import { FC, ReactNode, useEffect, useState } from 'react';
import { usePatientProfile } from '../../../../../hooks/use-patient-profile';
import { PatientProfileRoutePath } from '../navigation/route-config';
import { PatientProfilePageContext } from './context';

export interface PatientProfilePageProviderProps {
  children: ReactNode;
  id: number;
  view?: PatientProfileRoutePath;
}

export const PatientProfilePageProvider: FC<PatientProfilePageProviderProps> = (props) => {
  const { id, view } = props;
  const { loadPatientDataById } = usePatientProfile();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isReady, setIsReady] = useState<boolean>(false);
  const [route, setRoute] = useState<PatientProfileRoutePath>(PatientProfileRoutePath.OVERVIEW);

  useEffect(() => {
    if (!id) return;

    (async () => {
      setIsLoading(true);
      await loadPatientDataById(id);
      setRoute(PatientProfileRoutePath.OVERVIEW);
      setIsReady(true);
      setIsLoading(false);
    })();
  }, [id]);

  useEffect(() => {
    if (isReady && view) setRoute(view);
  }, [isReady, view]);

  const goTo = (newRoute: PatientProfileRoutePath) => {
    if (newRoute === route) return;
    setRoute(newRoute);
  };

  return (
    <PatientProfilePageContext.Provider
      value={{
        route,
        goTo,
        isLoading
      }}
    >
      {isReady && props.children}
    </PatientProfilePageContext.Provider>
  );
};
